<template>
  <div class="login-rect container win-drag-bar">
    <div class="login-show">
      <a class="logo-cloud login-logo" target="_blank" href="https://cloud.tencent.com">{{$t('core.TencentCloud')}}</a>
      <a class="logo login-logo" ref="logo" target="_blank" href="https://cloud.tencent.com/document/product/436/11366">
        COSBrowser
      </a>
    </div>
    <div class="login-form">
      <div class="logo login-logo hide"></div>

      <div class="login-form-container no-drag-bar">
        <!-- access-rules 接口未回来前先占位，避免先闪 AK 表单再切 OAuth 的视觉跳变 -->
        <div v-if="!accessRulesReady" class="login-form__loading">
          <qc-icon type="loading"></qc-icon>
        </div>

        <template v-else>
        <h2 class="login-form__title">
          {{ akLoginDisabled ? $t('cos.oauth_login') : $t('core.key_login') }}
        </h2>

        <!-- key login start：仅当未被全局 access-rules 停用 AK 时展示 -->
        <div v-if="!akLoginDisabled">
          <ul class="cos-form__list">
            <li class="cos-form__item">
              <div class="cos-form__label">SecretID</div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_id')"
                v-model.trim="SecretId" @keyup="Remark='';Remember=false">
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">SecretKey</div>
              <input type="password" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_key')"
                v-model.trim="SecretKey">
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">
                {{`${$t('cos.bucket[0]')}/${$t('cos.access_path[0]')}`}}
                <qc-bubble :append-to-body="false" trigger="hover" placement="top" type="dark"
                  class="custom-login-bubble">
                  <i class="sk-login_pathic"></i>
                  <template slot="popup">{{$t('cos.tips.whether_to_enter_access_path')}}</template>
                </qc-bubble>
              </div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.add_path')"
                v-model.trim="AccessPath" @change="checkAccessChange">
            </li>
            <li class="cos-form__item cos-form-area" v-if="AccessPath">
              <div class="cos-form__label ">{{$t('cos.region_name')}}</div>
              <div class="cos-form__select-list">
                <qc-autocomplete :placeholder="$t('cos.placeholder.region')" v-model.trim="Region" trigger="focus"
                  :options="regionList" class="full-width"></qc-autocomplete>
              </div>
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">{{$t('core.remark')}}</div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.add_remark')"
                v-model.trim="Remark">
            </li>
            <li class="cos-form__item">
              <p class="mt-20">
                <label class="form-ctrl-label">
                  <input type="checkbox" class="tc-15-checkbox" v-model="Remember">{{$t('cos.remember_session')}}
                </label>
                <label class="pull-right">
                  <a v-if="oauthLoading" href="javascript:;">
                    <qc-icon type="loading"></qc-icon>
                  </a>
                  <a v-else href="javascript:void(0)" @click="onQcloudLogin">{{$t('cos.oauth_login')}}</a>
                </label>
              </p>
            </li>
          </ul>
        </div>
        <!-- key login end -->

        <!-- AK 登录被全局禁用时：副标题 + OAuth 主按钮 + 客户端下载入口，避免页面过于寡淡 -->
        <template v-if="akLoginDisabled">
          <p class="login-form__subtitle">{{$t('cos.oauth_login_subtitle')}}</p>
          <button type="button" class="tc-15-btn full-width login-btn"
            :disabled="oauthLoading" @click="onQcloudLogin">
            <qc-icon v-if="oauthLoading" type="loading"></qc-icon>
            <span v-else>{{$t('cos.oauth_login')}}</span>
          </button>

          <div class="login-divider">
            <span class="login-divider__text">{{$t('cos.download_client_divider')}}</span>
          </div>

          <ul class="client-download-list">
            <li v-for="item in clientDownloads" :key="item.key" class="client-download-item">
              <a :href="item.url" target="_blank" rel="noopener noreferrer"
                class="client-download-link" :title="$t('cos.download_client_tip')">
                <span class="client-download-icon" v-html="item.icon"></span>
                <span class="client-download-label">{{item.label}}</span>
              </a>
            </li>
          </ul>
        </template>

        <button v-else type="button" class="tc-15-btn full-width login-btn" @click="loginUser">{{$t('core.login')}}</button>

        <!-- 仅 AK 可用时才显示「获取密钥」「历史会话」入口 -->
        <div v-if="!akLoginDisabled" class="mt-20 text-center">
          <a :href="loginCamUrl" class="login-operate"
            target="_blank">{{$t('cos.get_secret_key')}}</a>
          <router-link to="/history" replace class="login-operate">{{$t('cos.history_session')}}</router-link>
        </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
// import adCorner from '@/components//common/adCorner';
import dialog from '@/scripts/tools/dialog';
import { tips, getQcloudSign, getQcloudApiCommonParams } from '@/scripts/tools/utils';
import user from '@/scripts/helper/user';
import menu from '@/scripts/helper/menu';
import keyBox from '@/scripts/helper/keyBox';
import { regions } from '@/scripts/tools/config';
import oauth from '@/scripts/helper/oauth';
import storage from '@/scripts/tools/storage';
import eventProxy from '@/scripts/tools/eventProxy';
import dao from '@/scripts/helper/dao';

export default {
  components: {
    // adCorner,
  },
  data() {
    return {
      SecretId: '',
      SecretKey: '',
      AccessPath: '',
      Region: '',
      Remark: '',
      Remember: false, // 记住会话

      regionList: [],
      showQcloudLogin: false, // 打开 oauth 登录弹窗
      oauthLoading: false, // 显示 oauth 网址加载中
      showRefreshQcloudLogin: false, // 显示刷新 oauth 登录的按钮
      webview: {},
      loginCamUrl: `https://${this.$store.consoleDomain}/cam/capi`,
    };
  },
  // AK 全禁用态下展示的客户端下载入口
  // icon 内联 svg，避免引入额外资源；currentColor 着色，hover 时由 css 控制
  // svg 字符串整体单行便于直接挂到 v-html，超 300 字符 max-len 单行豁免
  // url：windows/mac/linux 走 cosbrowser 下载站（按 officialDomain 切国内/海外，见 clientDownloads computed）；
  //      android/ios 走应用市场（国内外都用同一个，写死 path）
  /* eslint-disable max-len */
  clientDownloadConfig: [
    {
      key: 'windows',
      path: '/cosbrowser-setup-latest.exe',
      icon: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M3 5.48 10.27 4.5v6.96H3V5.48zm0 13.04L10.27 19.5v-6.96H3v5.98zM11.27 4.36 21 3v8.46H11.27V4.36zm0 16.28L21 21v-8.46H11.27v8.1z"/></svg>',
    },
    {
      key: 'mac',
      path: '/cosbrowser-latest.dmg',
      icon: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M16.36 12.78c-.02-2.4 1.96-3.55 2.05-3.61-1.12-1.63-2.85-1.86-3.47-1.89-1.48-.15-2.88.87-3.63.87-.75 0-1.91-.85-3.14-.83-1.62.02-3.11.94-3.94 2.39-1.68 2.91-.43 7.22 1.22 9.59.8 1.16 1.75 2.46 2.99 2.41 1.2-.05 1.65-.78 3.1-.78 1.45 0 1.85.78 3.12.75 1.29-.02 2.11-1.17 2.9-2.34.91-1.34 1.29-2.64 1.31-2.71-.03-.01-2.51-.96-2.51-3.85zM13.95 5.6c.66-.8 1.1-1.92.98-3.03-.95.04-2.1.63-2.78 1.43-.61.71-1.14 1.83-1 2.93 1.06.08 2.14-.54 2.8-1.33z"/></svg>',
    },
    {
      key: 'linux',
      path: '/cosbrowser-latest-linux.zip',
      icon: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M12 2c-2.21 0-4 1.79-4 4 0 .47.1.91.24 1.33C7.27 8.86 6 11.31 6 14c0 .73.1 1.43.27 2.1-.79.54-1.27 1.45-1.27 2.4 0 .39.08.76.22 1.1C4.49 19.86 4 20.39 4 21c0 .55.45 1 1 1h14c.55 0 1-.45 1-1 0-.61-.49-1.14-1.22-1.4.14-.34.22-.71.22-1.1 0-.95-.48-1.86-1.27-2.4.17-.67.27-1.37.27-2.1 0-2.69-1.27-5.14-2.24-6.67.14-.42.24-.86.24-1.33 0-2.21-1.79-4-4-4zm-1.5 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 9c.83 0 1.5.45 1.5 1s-.67 1-1.5 1-1.5-.45-1.5-1 .67-1 1.5-1zm-3.5 5.5c.5 1 1.83 2.5 3.5 2.5s3-1.5 3.5-2.5c.27.55.5 1.27.5 2 0 1.93-1.79 3.5-4 3.5s-4-1.57-4-3.5c0-.73.23-1.45.5-2z"/></svg>',
    },
    {
      key: 'android',
      url: 'https://sj.qq.com/myapp/detail.htm?apkName=com.qcloud.cos.client',
      icon: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M17.6 9.48l1.84-3.18a.4.4 0 0 0-.69-.4l-1.86 3.22a11.39 11.39 0 0 0-9.78 0L5.25 5.9a.4.4 0 0 0-.69.4L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 7 15.25zm10 0a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1-1.25 1.25z"/></svg>',
    },
    {
      key: 'ios',
      url: 'https://apps.apple.com/cn/app/id1469323992',
      // 手机轮廓 icon，跟 Android 形成 “手机端两兄弟” 的视觉呼应，避免和 mac 撞 Apple logo
      icon: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.2"/><line x1="10.5" y1="5" x2="13.5" y2="5"/><circle cx="12" cy="18.5" r="0.9" fill="currentColor" stroke="none"/></svg>',
    },
  ],
  /* eslint-enable max-len */
  computed: {
    // AK 白名单登录场景（?loginType=ak&appid=X 私链引导，只发给个别客户）
    //   - loginType 精确匹配 'ak'
    //   - appid 必须是 6~15 位数字（跟接入层校验一致）
    // 命中时：
    //   1. App.vue 启动时会带这个 appid 调 /api/access-rules/me，命中白名单则返回 blockedAuth=[]
    //   2. akLoginDisabled 自然为 false → 显示 AK 表单
    //   3. loginUser 提交时会走 ak-login 握手接口
    akWhitelistLogin() {
      const q = this.$route && this.$route.query;
      if (!q) return { enabled: false, appid: '' };
      const { loginType, appid } = q;
      if (loginType !== 'ak') return { enabled: false, appid: '' };
      if (!appid || !/^\d{6,15}$/.test(String(appid))) return { enabled: false, appid: '' };
      return { enabled: true, appid: String(appid) };
    },
    // 全局是否停用 AK/SK 登录（由 App.vue 启动时调 /api/access-rules/me 拿到）。
    // 停用后 UI 只展示 OAuth 登录入口，且不暴露历史会话、获取密钥等 AK 相关链接。
    akLoginDisabled() {
      const list = this.$store.globalBlockedAuth;
      return Array.isArray(list) && list.includes('ak');
    },
    // /api/access-rules/me 是否已返回（成功或失败都算）。未 ready 时登录页不渲染表单，
    // 避免先按默认值闪一下 AK 表单又切到 OAuth 的视觉跳变。
    accessRulesReady() {
      return !!this.$store.accessRulesReady;
    },
    // AK 禁用态下展示的 5 个客户端下载项（label 走 i18n，icon/url 来自上面的静态配置）
    // 桌面端三项 (windows/mac/linux) 用 path 拼接 cosbrowser 下载站域名：
    // 国内站 cosbrowser.cloud.tencent.com / 海外站 cosbrowser.tencentcloud.com，避免国内用户跳海外慢
    clientDownloads() {
      const isIntl = this.$store.officialDomain && this.$store.officialDomain.endsWith('.tencentcloud.com');
      const downloadHost = isIntl ? 'https://cosbrowser.tencentcloud.com' : 'https://cosbrowser.cloud.tencent.com';
      return this.$options.clientDownloadConfig.map(item => ({
        ...item,
        url: item.url || `${downloadHost}${item.path}`,
        label: this.$t(`cos.client_platform.${item.key}`),
      }));
    },
  },
  mounted() {
    storage.del('userInfo');
    this.initData();
    this.handleRegionList();
    eventProxy.on('OPEN_OAUTH_LOGIN', this.onQcloudLogin);
  },
  destroyed() {
    eventProxy.off('OPEN_OAUTH_LOGIN', this.onQcloudLogin);
  },
  methods: {
    async initData() {
      const info = await keyBox.getLastSession();
      if (info) {
        this.changeInfo(info);
      }
    },
    handleRegionList() {
      const language = this.$store.localeLanguage;
      const regionList = regions.filter(v => !v.hidden);
      this.regionList = regionList.map(item => {
        let label = '';
        if (language === 'zh') {
          const labelLan = `label_${language}`;
          label = `(${item[labelLan]})`;
        }
        return {
          label: item.region + label,
          value: item.region,
        };
      });
    },
    changeInfo(info) {
      this.SecretId = info.SecretId;
      this.SecretKey = info.SecretKey;
      this.AccessPath = info.AccessPath;
      this.Region = info.Region;
      this.Remark = info.Remark;
      this.Remember = info.Remember;
    },
    checkAccessChange() {
      if (!this.AccessPath) {
        this.Region = '';
      }
      this.AccessPath = this.AccessPath.replace(/\/*$/, '/')
        .replace(/^\/+/, '')
        .replace(/\/{2,}/, '/');
    },
    checkRemember() {
      return new Promise(resolve => {
        const existSession = keyBox.sessionIsExist(this.SecretId);
        if (!this.Remember && !this.AccessPath && existSession) {
          const message = this.$t('cos.confirm.check_remember');
          dialog.confirm({ message }, confirm => {
            if (confirm) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    validate() {
      let allow = true;
      let errMsg = '';
      // 检查基本错误
      if (!this.SecretId) {
        allow = false;
        errMsg = this.$t('cos.validate.secret_id_empty');
      }
      if (!this.SecretKey) {
        allow = false;
        errMsg = this.$t('cos.validate.secret_key_empty');
      }
      // if (this.SecretId.length !== 36) return errMsg = this.$t('cos.validate.secret_id_format');
      // if (!this.SecretId.startsWith('AKID')) return errMsg = this.$t('cos.validate.secret_key_must_start_with_AKID');
      // if (this.SecretKey.length !== 32) return errMsg = this.$t('cos.validate.secret_key_format');

      if (!this.AccessPath) {
        this.Region = '';
      } else if (this.$store.IsQCloudCos) {
        if (this.Region === '') {
          allow = false;
          errMsg = this.$t('cos.validate.region_key_empty');
        } else {
          const { AccessPath } = this;
          const Bucket = AccessPath.substr(0, AccessPath.indexOf('/'));
          if (!Bucket.length) {
            errMsg = this.$t('cos.validate.empty_input_content');
            allow = false;
          } else if (Bucket.length > 50) {
            errMsg = this.$t('cos.validate.bucket_name_length');
            allow = false;
          } else if (!/^[a-zA-Z0-9_-]{1,40}-[0-9]{1,10}$/.test(Bucket)) {
            errMsg = this.$t('cos.validate.bucket_name_char');
            allow = false;
          }
        }
      }

      // FIX: 直接校验 AKID 会导致国际站账号无法登陆，因此去掉该校验
      // // 校验公有云域名的 secretId 是否正确填写
      // if (this.$store.IsQCloudCos && !this.SecretId.startsWith('AKID')) {
      //   errMsg = this.$t('error.secretIdError');
      //   allow = false;
      // }

      if (errMsg) tips.error(errMsg);
      return allow;
    },
    // AK 白名单登录握手：本地用 SK 签好 cam.GetUserAppId 请求，POST 给接入层。
    // 接入层透传到 cam.tencentcloudapi.com 拿真实 AppId，与前端声明的 appid 比对，
    // 一致则签发 cosbrowser_ticket cookie。SK 不出浏览器，符合项目一贯原则。
    //
    // 参考：dao.js 的 getUserInfo 也是用同样的方式在本地签名调 cam.GetUserAppId。
    // 差别是这里不走 /cos/others/cloudapi 通用转发（此路径已被 access-rules 中间件拦），
    // 而是走 /api/ak-login/handshake 专用握手接口（不经 access-rules 中间件）。
    //
    // 返回：true 表示握手成功可以继续登录流程；false 表示中断
    async doAkWhitelistHandshake() {
      const { appid } = this.akWhitelistLogin;
      const secretId = this.SecretId;
      const secretKey = this.SecretKey;

      // 本地构造签名（同 dao.getUserInfo 的签名方式，SK 全程只在浏览器）
      const commonParams = getQcloudApiCommonParams(secretId);
      const requestData = {
        ...commonParams,
        Action: 'GetUserAppId',
        Version: '2019-01-16',
      };
      const host = 'cam.tencentcloudapi.com';
      requestData.Signature = getQcloudSign('POST', requestData, secretKey, host);

      tips.loading(this.$t('core.loading'));
      try {
        await dao.postAkLoginHandshake({
          appid,
          signedCamRequest: requestData,
        });
        tips.closeTips();
        return true;
      } catch (err) {
        tips.closeTips();
        // dao.js 拦截器把业务错误直接 reject 出来：{ code: -1, errCode, message }
        const message = (err && err.message) || this.$t('error.networkError');
        tips.error(message);
        return false;
      }
    },
    async loginUser() {
      if (!this.validate()) return;

      const confirm = await this.checkRemember();
      if (!confirm) return;

      // AK 白名单登录握手：仅在 ?loginType=ak&appid=X 私链场景走
      //   - 前端本地用 SK 签好 cam.GetUserAppId 请求（SK 不出浏览器）
      //   - 发给接入层 /api/ak-login/handshake 校验 AK 归属 + 签发 cookie
      //   - 握手成功后再走 user.setCredential 正常登录流程
      //   - 握手失败 → toast 报错，登录流程中断
      if (this.akWhitelistLogin.enabled) {
        const ok = await this.doAkWhitelistHandshake();
        if (!ok) return;
      }

      user.changeLoginMethod('SecretKey');

      const credential = {
        SecretId: this.SecretId,
        SecretKey: this.SecretKey,
        AccessPath: this.AccessPath,
        Region: this.Region,
        Remark: this.Remark,
        Remember: this.Remember,
      };
      user.setCredential(credential);

      const { AccessPath, Region } = this;
      if (AccessPath && Region) {
        user.login({ keyType: 'SecretKey' });
        this.$store.showSideBar = false;
        // this.computeCrumbs(AccessPath, Region);
      } else {
        tips.loading(this.$t('core.loading'));
        menu.getList(data => {
          const result = data.result || {};
          tips.closeTips();

          // 过滤掉子账号登录的报错
          if (result.message) {
            if (
              AccessPath
              && result.message
                === this.$t('error.needAccessPathOrGetServiceAccess')
            ) {
              // console.log('子账号登录,忽略报错信息');
            } else {
              tips.error(result.message);
            }
          }

          if (result.allow) {
            user.login({ keyType: 'SecretKey' });
            // this.computeCrumbs();
          } else {
            user.setCredential(null);
          }
        });
      }
    },
    async onQcloudLogin() {
      if (this.oauthLoading) return;

      this.showRefreshQcloudLogin = false;
      this.oauthLoading = true;
      const url = await oauth.getCloudLoginUrl();
      this.oauthLoading = false;
      if (!url) return;
      this.oauthLoading = true;
      const { clientId, clientCode } = oauth;
      storage.add('oauth_cache', { clientId, clientCode });
      if (this.$route.query.r_path) {
        storage.add('login_path', this.$route.query.r_path, 'session');
      }
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-rect{
  max-width: 1000px;
  max-height:680px;
  min-width: 500px;
  min-height: 620px;
  margin: auto;
  border: 1px solid #DEE1E6;
}
.full-width {
  width: 100%;
}
.custom-login-bubble {
  ::v-deep .tc-15-bubble-inner {
    padding: 8px 12px;
  }
}
// access-rules 接口未回来前的占位，撑住跟"最终表单"差不多的高度，避免容器抖动
.login-form__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  color: #888;
  font-size: 20px;
}

// ===== AK 禁用态下的辅助 UI（副标题 / 分隔线 / 客户端下载入口）=====
// 设计目标：在仅剩 OAuth 一个按钮的极简登录页里补足视觉重量，避免右半屏过空，
// 同时给"安装 COSBrowser 客户端"这条 toast 文案提供实际可点的出口。
.login-form__subtitle {
  margin: 0 0 24px;
  font-size: 13px;
  line-height: 20px;
  color: #888;
  text-align: left;
}
.login-divider {
  position: relative;
  margin: 32px 0 20px;
  text-align: center;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    background-color: #E5E5E5;
  }
  &__text {
    position: relative;
    display: inline-block;
    padding: 0 12px;
    background-color: #fff;
    font-size: 12px;
    color: #999;
  }
}
.client-download-list {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.client-download-item {
  flex: 0 0 auto;
}
.client-download-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  color: #666;
  text-decoration: none;
  background-color: #fff;
  transition: border-color .2s, color .2s, box-shadow .2s, transform .2s;
  &:hover {
    border-color: #006EFF;
    color: #006EFF;
    box-shadow: 0 2px 8px rgba(0, 110, 255, 0.12);
    transform: translateY(-1px);
    text-decoration: none;
  }
}
.client-download-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  line-height: 0;
}
.client-download-label {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1;
}

// 云账号登录弹窗样式
.qcloud-login__mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  transition: all 0.2s;
  text-align: center;
  white-space: nowrap;
}
.qcloud-login-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  box-shadow: 1px 1.73px 20px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #fff;
  -webkit-app-region: no-drag;

  button {
    position: absolute;
    height: 30px !important;
    &.qcloud-login__close {
      right: 20px;
      top: 10px;
    }
    &.qcloud-login__refresh {
      right: 55px;
      top: 10px;
    }
  }

  webview {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
